import React, { useEffect, useRef } from 'react';
import interact from 'interactjs';

function preventCaret(event) {
  event.preventDefault();
}

// props: { gap, active, onStart(gap), onMove(delta), onEnd() }. The latest props are read on each event,
// so the interactable is set up once.
function GapHandle(props) {

  const handleReference = useRef(null);
  const propsReference = useRef(props);

  propsReference.current = props;

  useEffect(function onLoad() {

    const interactable = interact(handleReference.current).draggable({
      listeners: {
        start() {
          propsReference.current.onStart(propsReference.current.gap);
        },
        move(event) {
          propsReference.current.onMove(event.clientX - event.clientX0);
        },
        end() {
          propsReference.current.onEnd();
        }
      },
      cursorChecker() {
        return 'col-resize';
      }
    });

    return function onUnload() {
      interactable.unset();
    };

  }, []);

  let className = 'layout-gap-handle';

  if (props.active === true) {
    className = className + ' active';
  }

  const attributes = {
    className,
    contentEditable: false,
    role: 'separator',
    'aria-orientation': 'vertical',
    'aria-label': 'Drag to resize items',
    ref: handleReference,
    onMouseDown: preventCaret,
    style: { left: props.gap.x + 'px', top: props.gap.top + 'px', height: props.gap.height + 'px' }
  };

  return <div {...attributes}><span className="layout-gap-handle-line"></span></div>;

}

export default GapHandle;
